import type { HTMLAttributes } from 'react';

type Size = 'sm' | 'md' | 'lg';

export interface SpinnerProps extends HTMLAttributes<HTMLSpanElement> {
  size?: Size;
  label?: string;
}

export function Spinner({
  size = 'md',
  label = 'Loading',
  className,
  ...rest
}: SpinnerProps) {
  const cls = ['pn-spinner', `pn-spinner-${size}`, className].filter(Boolean).join(' ');
  return <span className={cls} role="status" aria-label={label} {...rest} />;
}
